const LOCAL_STORAGE_KEY = {
	SHOW_SITE_GPT: 'showSiteGpt',
	TOKEN: 'token',
	REFRESH: 'refresh',
	USER_NAME: 'userName',
	USER_ID: 'userId',
	SESSION_EXPIRED: 'session_expired',
	LAST_EXTRACTION_DATES: 'last_extraction_dates',
	PRICING_ELASTICY_SENT: 'pricing_elasticy_sent',
	ORGANIZATION_GOBACK: 'organization_go_back',
	LAST_ORDER_PURCHASE: 'lastOrderPurchase',
	/**
	 * Compra FALSA para diseñar la pantalla de éxito sin comprar. Vive en una
	 * llave aparte a propósito: `LAST_ORDER_PURCHASE` es la compra real y no se
	 * toca, así que apagar `VITE_PURCHASE_PREVIEW` devuelve el comportamiento de
	 * producción aunque el fixture siga escrito. Solo se lee cuando esa env está
	 * prendida; en el bundle de prod la rama ni existe.
	 */
	PREVIEW_ORDER_PURCHASE: 'previewOrderPurchase',
	IS_FROM_IOS: 'isFromIOS',
	PLATFORM_OS: 'platformOS',
	SUBSCRIPTION_ID: 'subscription_id',
	ACCEPTED_NSS_VALIDATION: 'accepted_nss_validation',
	SHOW_MODAL_RECENT_ACQUISITION: 'show_modal_recent_acquisition',
	REFERRALS_PROMO_LAST_SHOWN: 'referrals_promo_last_shown',
	TERMS_RECONSENT_LAST_SHOWN: 'terms_reconsent_last_shown',
	/** sessionStorage (no localStorage): quien acaba de re-firmar los términos
	 * no ve el popup de referidos en ESA sesión — sale hasta el próximo ingreso. */
	TERMS_RECONSENT_ACCEPTED_THIS_SESSION: 'terms_reconsent_accepted_this_session',
	WRAPPED_2025_VIEWED: 'wrapped_2025_viewed',
	/** NPS (t-015): ISO de la última vez que el modal se MOSTRÓ en este
	 * navegador (respondido o no) y de la última respuesta. Una vez por
	 * ventana; la verdad final la tiene el backend (users.nps). */
	NPS_LAST_SHOWN: 'nps_last_shown',
	NPS_LAST_ANSWERED: 'nps_last_answered',
	REFERRAL_CODE: 'referral_code',
	REFERRAL_ID: 'referral_id',
	REFERRAL_CAMPAIGN_ID: 'referral_campaign_id',
	/** Clic de afiliado (Affise): `{clickId, pid, source, capturedAt}`. Es la
	 * llave con la que se factura la comisión — ver shared/attribution/affiliate.ts. */
	AFFILIATE_CLICK: 'affise_clickid',
	DEBUG_PLATFORM_OVERRIDE: 'debug_platform_override',
};

export default LOCAL_STORAGE_KEY;
